import SVGIconWrapper from "./SVGIconWrapper"

const IconCloseBold = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#000000"}
        style={props.style}
        viewBox="0 0 500 500"
        iconClass={`icon--close-bold ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <path fillRule="evenodd" d="M500 61.9L438.1 0 250 188.1 61.9 0 0 61.9 188.1 250 0 438.1 61.9 500 250 311.9 438.1 500l61.9-61.9L311.9 250 500 61.9z" />
    </SVGIconWrapper>
)

export default IconCloseBold